import { I18n } from '@calendly/i18n'

/**
 * Generates payment information text for the expanded details view (e.g. "$7.00 USD paid via Stripe").
 * Coupon/discount is not included here; the subtitle under the invitee name shows that when present.
 * @param {Object} charge - The charge object containing payment and coupon info
 * @param {boolean} shouldShow - Whether to show payment info (hasCharge or showCharge)
 * @returns {string|null} - Formatted payment info string or null
 */
export const getPaymentInfo = (charge, shouldShow) => {
  if (!shouldShow) return null

  return I18n.t('publisher.dashboard.invitee.paid_via', {
    amount_with_symbol: charge.amountWithSymbol,
    currency: charge.currency,
    provider_name: charge.providerName,
  })
}

/**
 * Generates the payment subtitle text shown under the invitee name (e.g. "$10.00 paid" or "$10.00 paid, 20% discount").
 * Uses amount_paid or amount_paid_with_discount i18n keys based on whether a booking code/discount is present.
 * @param {Object|null|undefined} charge - The charge object (with optional bookingCodeInfo)
 * @returns {string|null} - Formatted subtitle string or null if no charge
 */
export const getPaymentSubtitleText = (charge) => {
  if (!charge) return null

  if (charge.bookingCodeInfo) {
    const discount = charge.bookingCodeInfo.bookingCodeType === 'FIXED'
      ? charge.bookingCodeInfo.discountValueWithSymbol
      : `${charge.bookingCodeInfo.percentOff}%`
    return I18n.t('publisher.dashboard.invitee.amount_paid_with_discount', {
      amount: charge.amountWithSymbol,
      discount,
    })
  }

  return I18n.t('publisher.dashboard.invitee.amount_paid', { amount: charge.amountWithSymbol })
}
